import styled from 'styled-components';

export const StyledBurger = styled.button`
  //position: absolute;
  //top: 50%;
  //left: 2rem;
  //right: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  color:#FFF;

  &:focus {
    outline: none;
  }

 div {
    width: 2rem;
    height: 0.25rem;
    background:#C00000;
    color:inherit;
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    //color: #C0000;
    :first-child {
      transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }
    :nth-child(2) {
      opacity: ${({ open }) => open ? '0' : '1'};
      //transform: ${({ open }) => open ? 'translateX(20px)' : 'translateX(0)'};
    }

        :nth-child(3) {
      transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }

`;